import { FunctionComponent } from 'react';
import { CoUserDetailsInfo } from 'widgets/CoUsers/ui/CoUserDetailsInfo';
import { PageWrapper } from 'pages/_layouts/PageWrapper';

export const CoUserDetailsInfoPage: FunctionComponent = () => {
	return (
		<PageWrapper>
			<CoUserDetailsInfo />
		</PageWrapper>
	);
};
